<template>
  <!-- フッター -->
  <div class="footer-wrapper">
    <div class="footer double-scroll-padding">
      <el-row>
        <el-col :span="12" class="actions">
          <router-link :to="returnTo" class="return">
            <jr-button type="info" size="small" class="return-btn">戻る</jr-button>
          </router-link>
        </el-col>
        <el-col :span="12" class="actions align-right">
          <router-link
            :to="{ name: 'ProximityEdit', params: { request_header_id: form.request_header_id } }"
            v-if="isActionBtnVisible"
          >
            <jr-button type="primary" size="small" class="edit-btn">変更</jr-button>
          </router-link>
          <proximity-detail-regist
            v-if="isEditBtnVisible"
            :form="form"
            :proximityId="proximityId"
            :formRef="formRef"
            :fileRefs="fileRefs"
            :isSave="isSave"
            :isShowConfirmDialog="isShowConfirmDialog"
            @update:errorFoundationDrawingFile="errorFoundationDrawingFile = $event"
            @update:errorWorkingRangeFile="errorWorkingRangeFile = $event"
            @update:isValid="isValid = $event"
            @update:notSaved="notSaved"
            @returnRoute="returnRoute"
          ></proximity-detail-regist>
          <router-link
            :to="{
              name: 'NormalMessageSend',
              params: {
                message_type: MessageTypes.P_APPLICANT_CALL,
                action: 'send',
                request_header_id: form.request_header_id,
              },
            }"
            v-if="isActionBtnVisible"
          >
            <jr-button-for-jr size="small" class="contact-btn">協議先連絡</jr-button-for-jr>
          </router-link>
        </el-col>
      </el-row>
    </div>
  </div>
  <el-form :model="form" :rules="rules" ref="formRef" class="double-scroll-padding">
    <!-- 申請基本 -->
    <input-group>
      <el-row class="input-row" v-if="isShow">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label> 申請番号 </input-label>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="applicant_number" class="applicant_number" size="small">
            <jr-text shadow="never" v-model="form.applicant_number" :isEdit="false" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row" v-if="isShow">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label> 申請日時 </input-label>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="applicant_time" class="applicant_time" size="small">
            <jr-date-time-picker size="small" v-model="form.applicant_time" :isEdit="false" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label :required="isEdit"> 担当保守区</input-label>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="department" class="department" size="small">
            <Suspense>
              <department-select
                v-model="form.department"
                @update:code="form.department_code = $event"
                @update:name="form.department_name = $event"
                size="small"
                :isEdit="isEdit"
                :isInstitution="true"
                :isElectricity="true"
              />
            </Suspense>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label :required="isEdit">標題</input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_title" class="applicant_title" size="small">
            <jr-text :isEdit="isEdit" v-model="form.applicant_title" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label :required="isEdit">キロ程</input-label>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="meter" class="meter" size="small">
            <input-kilo size="small" v-model="form.meter" :isEdit="isEdit" />
          </el-form-item>
        </el-col>
      </el-row>
    </input-group>
    <!-- お問い合わせ情報 -->
    <collapse-group title="お問い合わせ情報" :isOpen="isEdit">
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label><span>事業者名・部署名</span><span>（法人の場合）</span></input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_business_name" class="applicant_business_name">
            <jr-text :isEdit="isEdit" v-model="form.applicant_business_name" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit">担当者氏名</input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_manager_name" size="small" class="applicant_manager_name">
            <jr-text :isEdit="isEdit" v-model="form.applicant_manager_name" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit">住所</input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_address" size="small" class="applicant_address">
            <jr-text :isEdit="isEdit" v-model="form.applicant_address" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit">電話番号</input-label>
        </el-col>
        <el-col :span="10">
          <el-form-item prop="applicant_tel" size="small" class="applicant_tel">
            <jr-text :isEdit="isEdit" v-model="form.applicant_tel" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"><span>連絡先</span><span>メールアドレス</span></input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_email" size="small" class="applicant_email">
            <jr-text :isEdit="isEdit" v-model="form.applicant_email" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>
    <!-- 工事場所 -->
    <collapse-group title="工事場所" @change="mapCollapseChange" :isOpen="isEdit">
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 住所または地番 </input-label>
        </el-col>
        <el-col :span="14">
          <el-form-item prop="proximity.construction_address" size="small" class="construction_address">
            <jr-text :isEdit="isEdit" size="small" v-model="form.proximity.construction_address" />
          </el-form-item>
        </el-col>
        <el-col :span="5" style="padding-left: 4px" v-if="isEditBtnVisible">
          <jr-geocoder
            :address="form.proximity.construction_address"
            v-model:lat="mapCenterLat"
            v-model:lng="mapCenterLng"
            @change="changeMapCenter"
          >
            住所から地図を表示
          </jr-geocoder>
        </el-col>
      </el-row>
      <!-- 建物名 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 建物名 </input-label>
        </el-col>
        <el-col :span="14">
          <el-form-item prop="proximity.construction_building_name" size="small" class="construction_building_name">
            <jr-text :isEdit="isEdit" v-model="form.proximity.construction_building_name" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 路線・駅間 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 路線 </input-label>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="proximity.line" size="small" class="line">
            <Suspense>
              <line-select
                v-model="form.proximity.line"
                @update:name="form.proximity.line_name = $event"
                size="small"
                :isEdit="isEdit"
              />
            </Suspense>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 駅間 </input-label>
        </el-col>
        <el-col :span="6">
          <el-form-item
            prop="proximity.start_station"
            size="small"
            :error="validationError.start_station"
            class="start_station"
          >
            <Suspense>
              <station-select
                v-model="form.proximity.start_station"
                :lineCode="form.proximity.line"
                :filterByLine="true"
                @update:name="form.proximity.start_station_name = $event"
                size="small"
                :isEdit="isEdit"
              />
            </Suspense>
          </el-form-item>
        </el-col>
        <el-col :span="2" class="text-xs align-middle error-message-padding-small">
          <span class="mx-auto">～</span>
        </el-col>
        <el-col :span="6">
          <el-form-item
            prop="proximity.end_station"
            :error="validationError.end_station"
            size="small"
            class="end_station"
          >
            <Suspense>
              <station-select
                v-model="form.proximity.end_station"
                :lineCode="form.proximity.line"
                :filterByLine="true"
                @update:name="form.proximity.end_station_name = $event"
                size="small"
                :isEdit="isEdit"
              />
            </Suspense>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 線路近接の程度 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 線路近接の程度 </input-label>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="proximity.degree" size="small" class="degree">
            <jr-text :isEdit="isEdit" v-model="form.proximity.degree" placeholder="線路からの距離〇m" size="small" />
          </el-form-item>
          <el-col v-if="isEdit">
            <span class="text-xs caution-message">※線路内へは絶対に立ち入らないで下さい。</span>
          </el-col>
        </el-col>
      </el-row>
      <el-collapse v-if="!isEdit" @change="mapCollapseChange" class="map-collapse">
        <el-collapse-item title="工事場所">
          <el-form-item prop="proximity.construction_latitude" size="small" class="construction_latitude">
            <jr-map
              :centerLat="mapCenterLat"
              :centerLng="mapCenterLng"
              v-model:lat="form.proximity.construction_latitude"
              v-model:lng="form.proximity.construction_longitude"
              :zoom="mapZoom"
              :load="mapLoad"
              :isEdit="false"
              style="width: 100%; height: 600px"
            />
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
      <el-row v-if="isEdit">
        <el-col :span="12" class="construction-site-col">
          <input-label :required="true"> 工事場所 </input-label>
          <span>(地図上でクリックしてください。)</span><br />
          <span class="text-xs pl-1">マウスホイール（またはピンチ）により拡大・縮小できます。</span>
        </el-col>
      </el-row>
      <el-row v-if="isEdit">
        <el-col :span="24">
          <el-form-item prop="proximity.construction_latitude" size="small" class="construction_latitude">
            <jr-map
              v-model:centerLat="mapCenterLat"
              v-model:centerLng="mapCenterLng"
              v-model:lat="form.proximity.construction_latitude"
              v-model:lng="form.proximity.construction_longitude"
              :zoom="mapZoom"
              :isEdit="true"
              style="width: 100%; height: 600px"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>
    <!-- 工事内容 -->
    <collapse-group title="工事内容" :isOpen="isEdit">
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 工事内容 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item size="small" prop="proximity.construction_detail" class="construction_detail">
            <jr-text :isEdit="isEdit" v-model="form.proximity.construction_detail" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 工事種別 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 工事種別 </input-label>
        </el-col>
        <el-col :span="14">
          <el-form-item
            size="small"
            prop="proximity.construction_type"
            :error="validationError.construction_type"
            class="construction_type"
          >
            <Suspense>
              <construction-type-select v-model="form.proximity.construction_type" :isEdit="isEdit" size="small" />
            </Suspense>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label> (その他の場合記入) </input-label>
        </el-col>
        <el-col :span="19">
          <form-item-disabled
            prop="proximity.construction_type_other"
            class="construction_type_other"
            size="small"
            :disabled="form.proximity.construction_type !== constructionTypeOther"
          >
            <jr-text
              :isEdit="isEdit"
              :disabled="form.proximity.construction_type !== constructionTypeOther"
              v-model="form.proximity.construction_type_other"
              size="small"
            />
          </form-item-disabled>
        </el-col>
      </el-row>
      <!-- 施工目的 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 施工目的 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item size="small" prop="proximity.construction_purpose" class="construction_purpose">
            <jr-text :isEdit="isEdit" v-model="form.proximity.construction_purpose" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 重機使用有無 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> <span>工事用重機械</span><span>使用の有無</span> </input-label>
        </el-col>
        <el-col :span="7">
          <el-form-item size="small" prop="proximity.is_use_heavy" class="is_use_heavy">
            <jr-radio-group
              radioClass="is_use-heavy-radio"
              v-model="form.proximity.is_use_heavy"
              :labels="availableLabels"
              :isEdit="isEdit"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <form-item-disabled
            prop="proximity.use_heavy_remark"
            :disabled="form.proximity.is_use_heavy !== true"
            class="use_heavy_remark"
            :error="validationError.use_heavy_remark"
            size="small"
          >
            <jr-text
              v-model="form.proximity.use_heavy_remark"
              placeholder="10tダンプ、〇tクレーン、バックホウ、ユニック車"
              :isEdit="isEdit"
              :disabled="!form.proximity.is_use_heavy"
              size="small"
            />
          </form-item-disabled>
        </el-col>
      </el-row>
      <!-- 基礎工事有無 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 基礎工事の有無 </input-label>
        </el-col>
        <el-col :span="7">
          <el-form-item size="small" prop="proximity.is_foundation_work" class="is_foundation_work">
            <jr-radio-group
              radioClass="is_foundation_work-radio"
              v-model="form.proximity.is_foundation_work"
              :labels="availableLabels"
              :isEdit="isEdit"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <form-item-disabled
            prop="proximity.foundation_work_remark"
            :disabled="form.proximity.is_foundation_work !== true"
            class="foundation_work_remark"
            :error="validationError.foundation_work_remark"
            size="small"
          >
            <jr-text
              :isEdit="isEdit"
              :disabled="!form.proximity.is_foundation_work"
              v-model="form.proximity.foundation_work_remark"
              placeholder="直接基礎・杭基礎"
              size="small"
            />
          </form-item-disabled>
        </el-col>
      </el-row>
      <!-- 地盤改良 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 地盤改良等の有無 </input-label>
        </el-col>
        <el-col :span="7">
          <el-form-item size="small" prop="proximity.is_ground_completion" class="is_ground_completion">
            <jr-radio-group
              radioClass="is_ground_completion-radio"
              v-model="form.proximity.is_ground_completion"
              :labels="availableLabels"
              :isEdit="isEdit"
              size="small"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- JR用地使用 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> <span>JR用地</span><span>使用の有無</span> </input-label>
        </el-col>
        <el-col :span="7">
          <el-form-item size="small" prop="proximity.is_use_out_land" class="is_use_out_land">
            <jr-radio-group
              radioClass="is_use_out_land-radio"
              v-model="form.proximity.is_use_out_land"
              :labels="availableLabels"
              :isEdit="isEdit"
              size="small"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 防護設備 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> <span>線路内進入防止柵</span><span>等の設置</span> </input-label>
        </el-col>
        <el-col :span="7">
          <el-form-item size="small" prop="proximity.is_without_protective" class="is_without_protective">
            <jr-radio-group
              radioClass="is_without_protective-radio"
              v-model="form.proximity.is_without_protective"
              :labels="availableLabels"
              :isEdit="isEdit"
              size="small"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <form-item-disabled
            prop="proximity.without_protective_remark"
            :disabled="form.proximity.is_without_protective !== true"
            class="without_protective_remark"
            :error="validationError.without_protective_remark"
            size="small"
          >
            <jr-text
              :isEdit="isEdit"
              :disabled="!form.proximity.is_without_protective"
              v-model="form.proximity.without_protective_remark"
              placeholder="既設フェンス有、仮設フェンスを設置"
              size="small"
            />
          </form-item-disabled>
        </el-col>
      </el-row>
      <!-- 施工予定期間 -->
      <el-row class="input-row">
        <el-col :span="5" class="text-xs error-message-padding-small plan_date-label">
          <input-label :required="isEdit"> 施工予定期間 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item
            size="small"
            prop="proximity.end_plan_date"
            :error="validationError.end_plan_date"
            class="end_plan_date_error end_plan_date"
          >
            <el-form-item
              size="small"
              :error="validationError.start_plan_date"
              prop="proximity.start_plan_date"
              class="start_plan_date"
            >
              <jr-date-range-picker
                class="plan_date-range-picker"
                v-model:start="form.proximity.start_plan_date"
                v-model:end="form.proximity.end_plan_date"
                :isEdit="isEdit"
                size="small"
              />
            </el-form-item>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="isEdit">
        <el-col :offset="5" class="explanation-message font-xs">
          ・協議が必要な場合は、1ヶ月から2ヶ月程度の時間が掛かります。
        </el-col>
      </el-row>
      <el-row v-if="isEdit">
        <el-col :offset="5" class="explanation-message font-xs">
          ・電線の防護などが必要な場合は、4ヶ月から5ヶ月程度の時間が掛かります。
        </el-col>
      </el-row>
      <el-row v-if="isEdit">
        <el-col :offset="5" class="explanation-message font-xs">
          ・内容や混雑状況にもよりますので早めのご申請をお願いいたします。
        </el-col>
      </el-row>
    </collapse-group>
    <!-- 添付書類-->
    <collapse-group title="添付書類" class="file-area" :isOpen="isEdit">
      <el-row class="input-row" v-if="isEdit">
        <el-col class="explanation-message font-sm" :span="24"
          >※添付書類にはJR設備（線路やJR電線）との離隔を記載してください。</el-col
        >
      </el-row>
      <el-row class="input-row" v-if="isEdit">
        <el-col class="explanation-message font-sm" :span="24"
          >※写真は、可能な限り線路と対象地が入るように、JR用地外から撮影したものを添付してください。
        </el-col>
      </el-row>
      <el-row class="input-row" v-if="isEdit">
        <el-col class="explanation-message font-sm" :span="24">※線路内には絶対に入らないでください。 </el-col>
      </el-row>
      <el-row class="input-row" v-if="isEdit">
        <el-col class="explanation-message caution-message font-sm" :span="24"
          >※現地測量を行う際は、必ずJR用地外の安全な場所で実施して下さい。<br />
          <span class="pl-4">線路内への立入りや電気設備への接近は列車との接触や感電の危険性があり大変危険です。 </span
          ><br />
          <span class="pl-4">測量が困難な場合は概算距離（目測で可）を記載して下さい。</span>
        </el-col>
      </el-row>
      <el-row class="input-row bottom-explanation-message" v-if="isEdit">
        <el-col class="explanation-message font-sm" :span="24"
          >※形式はPDF,JPG,PNG,DOCX,DOC,XLSX,XLSで、1ファイル10Mまでとなります。
        </el-col>
      </el-row>
      <!-- 平面図 -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle ground_plan_file">
          <input-label :required="false">平面図</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a href="/kinsetsu/1.平面図.pdf" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item prop="proximity.ground_plan_file_selected" class="ground_plan_file_selected">
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.ground_plan_file"
              @update:selected="form.proximity.ground_plan_file_selected = $event"
              ref="ground_plan_file_ref"
              :fileType="FileTypes.PROXIMITY_GROUND_PLAN"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.ground_plan_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 断面図 -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle cross_section_file">
          <input-label :required="false">断面図</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a href="/kinsetsu/2.断面図.pdf" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item prop="proximity.cross_section_file_selected" class="cross_section_file_selected">
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.cross_section_file"
              @update:selected="form.proximity.cross_section_file_selected = $event"
              ref="cross_section_file_ref"
              :fileType="FileTypes.PROXIMITY_CROSS_SECTION"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.cross_section_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 仮設計画図 -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle plan_temporary_work_file">
          <input-label>仮設計画図</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a href="/kinsetsu/3.仮設計画図.pdf" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item prop="proximity.plan_temporary_work_file_selected" class="plan_temporary_work_file_selected">
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.plan_temporary_work_file"
              @update:selected="form.proximity.plan_temporary_work_file_selected = $event"
              ref="plan_temporary_work_file_ref"
              :fileType="FileTypes.PROXIMITY_PLAN_TEMPORARY_WORK"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.plan_temporary_work_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 重機配置図 -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle working_range_file">
          <input-label :required="false">重機配置図</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a href="/kinsetsu/4.重機配置図.pdf" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :error="errorWorkingRangeFile"
            prop="proximity.working_range_file_selected"
            class="working_range_file_selected"
          >
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.working_range_file"
              @update:selected="form.proximity.working_range_file_selected = $event"
              ref="working_range_file_ref"
              :fileType="FileTypes.PROXIMITY_WORKING_RANGE"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.working_range_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 現地写真１ -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle actual_place_photo_file">
          <input-label :required="false">現地写真１</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a href="/kinsetsu/5.現地写真.pdf" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item prop="proximity.actual_place_photo_file_selected" class="actual_place_photo_file_selected">
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.actual_place_photo_file"
              @update:selected="form.proximity.actual_place_photo_file_selected = $event"
              ref="actual_place_photo_file_ref"
              :fileType="FileTypes.PROXIMITY_ACTUAL_PLACE_PHOTO"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.actual_place_photo_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 現地写真２ -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle location_map_file">
          <input-label :required="false">現地写真２</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a href="/kinsetsu/5.現地写真.pdf" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item prop="proximity.location_map_file_selected" class="location_map_file_selected">
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.location_map_file"
              @update:selected="form.proximity.location_map_file_selected = $event"
              ref="location_map_file_ref"
              :fileType="FileTypes.PROXIMITY_LOCATION_MAP"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.location_map_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 現地写真３ -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle foundation_drawing_file">
          <input-label :required="false">現地写真３</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a href="/kinsetsu/5.現地写真.pdf" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :error="errorFoundationDrawingFile"
            prop="proximity.foundation_drawing_file_selected"
            class="foundation_drawing_file_selected"
          >
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.foundation_drawing_file"
              @update:selected="form.proximity.foundation_drawing_file_selected = $event"
              ref="foundation_drawing_file_ref"
              :fileType="FileTypes.PROXIMITY_FOUNDATION_DRAWING"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.foundation_drawing_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 現地写真４ -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle cadastral_map_file">
          <input-label>現地写真４</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a href="/kinsetsu/5.現地写真.pdf" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item prop="proximity.cadastral_map_file_selected" class="cadastral_map_file_selected">
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.cadastral_map_file"
              @update:selected="form.proximity.cadastral_map_file_selected = $event"
              ref="cadastral_map_file_ref"
              :fileType="FileTypes.PROXIMITY_CADASTRAL_MAP"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.cadastral_map_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- その他 -->
      <el-row class="input-row">
        <el-col :span="4" class="text-xs align-middle survey_drawing_of_acreage_file">
          <input-label>その他</input-label>
        </el-col>
        <el-col :span="2" v-if="isEdit">
          <a :href="sumpleSubmissionsUrl" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例
          </a>
        </el-col>
        <el-col :span="18">
          <el-form-item
            prop="proximity.survey_drawing_of_acreage_file_selected"
            class="survey_drawing_of_acreage_file_selected"
          >
            <jr-file-input
              v-if="isEdit"
              v-model="form.proximity.survey_drawing_of_acreage_file"
              @update:selected="form.proximity.survey_drawing_of_acreage_file_selected = $event"
              ref="survey_drawing_of_acreage_file_ref"
              :fileType="FileTypes.PROXIMITY_SURVEY_DRAWING_OF_ACREAGE"
              :allowExts="allowExts"
              :disabled="!isEdit"
            />
            <jr-file-view v-else :fileId="form.proximity.survey_drawing_of_acreage_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>
    <Suspense>
      <message-history-to-message-type
        :requestHeaderId="requestHeaderId"
        :targetMessageTypes="targetMessageTypes"
        v-if="isHistoryTableVisible"
      />
    </Suspense>
    <confirm-dialog
      @update:isShow="isShowDialog = $event"
      @update:comment="form.history_comment = $event"
      @update:isSave="isSave = $event"
      @update:isValid="isValid = $event"
      :isShow="isShowDialog"
    ></confirm-dialog>
  </el-form>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, watch, computed } from 'vue'
import { ElForm } from 'element-plus'
import { AxiosResponse } from 'axios'
import { useRouter } from 'vue-router'

import InputGroup from '@/components/layout/InputGroup.vue'
import JrText from '@/components/jr-parts/JrText.vue'
import JrDateTimePicker from '@/components/jr-parts/JrDateTimePicker.vue'
import JrDateRangePicker from '@/components/jr-parts/JrDateRangePicker.vue'
import InputKilo from '@/components/inputs/InputKilo.vue'
import InputLabel from '@/components/inputs/InputLabel.vue'
import DepartmentSelect from '@/components/inputs/DepartmentSelect.vue'
import CollapseGroup from '@/components/layout/CollapseGroup.vue'
import JrMap from '@/components/jr-parts/JrMap.vue'
import LineSelect from '@/components/inputs/LineSelect.vue'
import StationSelect from '@/components/inputs/StationSelect.vue'
import ConstructionTypeSelect from '@/components/inputs/ConstructionTypeSelect.vue'
import JrRadioGroup, { availableLabels } from '@/components/jr-parts/JrRadioGroup.vue'
import FormItemDisabled from '@/components/layout/FormItemDisabled.vue'
import JrFileInput from '@/components/jr-parts/JrFileInput.vue'
import JrFileView from '@/components/jr-parts/JrFileView.vue'
import JrButtonForJr from '@/components/jr-parts/JrButtonForJr.vue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import MessageHistoryToMessageType from '@/components/others/MessageHistoryToMessageType.vue'
import JrGeocoder from '@/components/jr-parts/JrGeocoder.vue'
import ProximityDetailRegist from '@/components/actions/ProximityDetailRegist.vue'
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'

import { isAfterToday } from '@/services/date'
import { FileTypes, RequestTypes, ConstructionTypes, APPLICANT_UPLOAD_FILE_EXTS } from '@/constants/enums'
import { RequestHeaderProximityDetailEditForm } from '@/types/forms'
import { ReadRequest } from '@/requests/requestHeader'
import { RequestHeaderDetail } from '@/api'
import { MessageTypes } from '@/constants/messageTypes'
import { proximityEditRule } from '@/constants/rules'
import { DEFAULT_CENTER_LAT, DEFAULT_CENTER_LNG, DEFAULT_ZOOM, PIN_ZOOM } from '@/constants/map'

export default defineComponent({
  emits: ['update:form'],
  name: 'ProximityInfo',
  components: {
    ConfirmDialog,
    InputGroup,
    JrText,
    JrDateTimePicker,
    InputKilo,
    InputLabel,
    DepartmentSelect,
    CollapseGroup,
    JrMap,
    LineSelect,
    StationSelect,
    JrDateRangePicker,
    ConstructionTypeSelect,
    JrRadioGroup,
    FormItemDisabled,
    JrFileInput,
    JrFileView,
    JrButtonForJr,
    JrButton,
    MessageHistoryToMessageType,
    JrGeocoder,
    ProximityDetailRegist,
  },
  props: {
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
    // 編集可能か
    isEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 申請番号・日時表示可否
    isShow: {
      type: Boolean,
      required: false,
      default: true,
    },
    // 一覧画面に戻るか
    returnToList: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 変更・協議先連絡等のボタン表示
    isActionBtnVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHistoryTableVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    // 保存ボタン表示
    isEditBtnVisible: {
      type: Boolean,
      required: false,
      default: false,
    },
    isShowConfirmDialog: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props, context) {
    const router = useRouter()
    const isShowDialog = ref<boolean>(false)
    const isValid = ref<boolean>(false)
    const isSave = ref<boolean>(false)
    const proximityId = ref<number | null>(null)
    const errorFoundationDrawingFile = ref<string>('')
    const errorWorkingRangeFile = ref<string>('')
    const formRef = ref<InstanceType<typeof ElForm>>()
    const mapCenterLat = ref<string>(DEFAULT_CENTER_LAT)
    const mapCenterLng = ref<string>(DEFAULT_CENTER_LNG)
    const mapZoom = ref<number>(DEFAULT_ZOOM)
    const changeMapCenter = () => {
      mapZoom.value = PIN_ZOOM
      // 中心座標変更時は工事場所住所をリセットする
      form.proximity.construction_latitude = ''
      form.proximity.construction_longitude = ''
    }
    /**
     * バックバリデーション
     **/
    // バックバリデーション型定義
    type backValidationType = {
      [key: string]: string
    }
    // 初期化したバックバリデーションメッセージ
    const initializedBackValid: backValidationType = {
      start_station: '',
      end_station: '',
      construction_type: '',
      use_heavy_remark: '',
      foundation_work_remark: '',
      without_protective_remark: '',
      end_plan_date: '',
      start_plan_date: '',
    }
    // バックバリデーション同期オブジェクト
    const validationError = ref<backValidationType>({ ...initializedBackValid })

    // GoogleMapを読み込むかどうか
    const mapLoad = ref<boolean>(false)
    const form = reactive<RequestHeaderProximityDetailEditForm>({
      request_header_id: undefined,
      history_comment: '新規登録',
      request_type: RequestTypes.PROXIMITY,
      applicant_number: '',
      applicant_time: '',
      department: -1,
      applicant_title: '',
      meter: undefined,
      applicant_email: null,
      applicant_business_name: '',
      applicant_manager_name: '',
      applicant_address: '',
      applicant_tel: '',
      is_tanto_department_login_user: false,
      proximity: {
        request_header: -1,
        construction_address: '',
        construction_building_name: '',
        line: '',
        line_name: '',
        start_station: -1,
        start_station_name: '',
        end_station: -1,
        end_station_name: '',
        degree: '',
        construction_latitude: '',
        construction_longitude: '',
        construction_detail: '',
        construction_type: -1,
        construction_type_other: null,
        construction_purpose: '',
        is_use_heavy: false,
        use_heavy_remark: null,
        is_foundation_work: false,
        foundation_work_remark: null,
        is_ground_completion: false,
        is_use_out_land: false,
        is_without_protective: false,
        without_protective_remark: null,
        start_plan_date: '',
        end_plan_date: '',
        location_map_file: -1,
        location_map_file_selected: false,
        ground_plan_file: -1,
        ground_plan_file_selected: false,
        cross_section_file: -1,
        cross_section_file_selected: false,
        actual_place_photo_file: -1,
        actual_place_photo_file_selected: false,
        foundation_drawing_file: null,
        foundation_drawing_file_selected: false,
        plan_temporary_work_file: null,
        plan_temporary_work_file_selected: false,
        working_range_file: null,
        working_range_file_selected: false,
        cadastral_map_file: null,
        cadastral_map_file_selected: false,
        survey_drawing_of_acreage_file: null,
        survey_drawing_of_acreage_file_selected: false,
      },
    })

    // ファイル関連
    const location_map_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const ground_plan_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const cross_section_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const actual_place_photo_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const foundation_drawing_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const plan_temporary_work_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const working_range_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const cadastral_map_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const survey_drawing_of_acreage_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const fileRefs = [
      location_map_file_ref,
      ground_plan_file_ref,
      cross_section_file_ref,
      actual_place_photo_file_ref,
      foundation_drawing_file_ref,
      plan_temporary_work_file_ref,
      working_range_file_ref,
      cadastral_map_file_ref,
      survey_drawing_of_acreage_file_ref,
    ]

    //履歴表示対象のメッセージ種別
    const targetMessageTypes: number[] = [
      MessageTypes.P_APPLICANT_CALL,
      MessageTypes.P_APPLICANT_CALL_RECV,
      MessageTypes.P_APPLICANT_CALL_SENDER_CALL,
      MessageTypes.APPLICANT_REGIST_PROXIMITY,
      MessageTypes.CHANGE_PROXIMITY_NOTICE,
      MessageTypes.PROXY_REGIST_PROXIMITY_NOTICE,
    ]

    // 初回とID変更時に情報を取得する
    watch(
      () => props.requestHeaderId,
      async (id: number) => {
        proximityId.value = null
        if (id) {
          const request = new ReadRequest(id)
          await request.exec()
          if (request.success) {
            const { data } = request.getResponse() as AxiosResponse<RequestHeaderDetail>
            if (data.request_type !== RequestTypes.PROXIMITY) {
              // 近接工事では無ければ404へ飛ばす
              router.push({ name: 'NotFound' })
              return
            }
            const proximity = request.getProximity()
            proximityId.value = proximity.proximity.proximity_id as number
            // 取得した情報をformに入れる
            Object.assign(form, proximity)
            mapZoom.value = PIN_ZOOM
            mapCenterLat.value = proximity.proximity.construction_latitude
            mapCenterLng.value = proximity.proximity.construction_longitude
          }
        }
      },
      { immediate: true }
    )

    // form変更時はemitする
    watch(
      () => form,
      () => {
        context.emit('update:form', form)
      },
      { deep: true }
    )

    watch(
      () => isValid.value,
      () => {
        if (isValid.value) {
          isSave.value = false
          if (!validate()) {
            // フロントバリデーション失敗時
            isValid.value = false
            return false
          }

          if (props.isShowConfirmDialog) {
            // 申請変更時
            isShowDialog.value = true
          } else {
            // 申請登録時
            isSave.value = true
          }
        }
      }
    )
    watch(
      () => [form.proximity.working_range_file_selected, form.proximity.is_use_heavy],
      () => {
        errorWorkingRangeFile.value = ''
      }
    )
    watch(
      () => [form.proximity.foundation_drawing_file_selected, form.proximity.is_foundation_work],
      () => {
        errorFoundationDrawingFile.value = ''
      }
    )

    // 戻り先
    const returnTo = computed(() => {
      if (props.returnToList) {
        let screen = ''
        if (props.isEdit) {
          screen = 'add'
        } else {
          screen = 'detail'
        }
        return {
          name: 'ProximityList',
          query: {
            screen: screen,
          },
        }
      } else {
        return {
          name: 'ProximityDetail',
          params: {
            request_header_id: props.requestHeaderId,
          },
        }
      }
    })
    // バリデーション
    const validate = () => {
      validationError.value = { ...initializedBackValid } // バックバリデーションも初期化
      let result = true
      if (formRef.value) {
        formRef.value.validate((valid) => {
          if (!valid) {
            // チェックNG
            result = false
          }
        })
      }
      return result
    }
    const returnRoute = () => {
      router.push(returnTo.value)
    }

    // 保存処理がキャンセルされた場合の処理
    const notSaved = (backValidResponse?: AxiosResponse | null) => {
      isSave.value = false
      isValid.value = false
      if (!backValidResponse) {
        return
      }
      displayBackValid(backValidResponse)
    }

    // バックバリデーションを表示
    const displayBackValid = (backValidResponse: AxiosResponse) => {
      // カスタムバックバリデーションのレスポンスタイプ変換
      type customBackValidResponseType = {
        [key: string]: string[]
      }
      // 型変換(そのままではブラケット記法を利用できないため)
      const changedResponseType = backValidResponse as unknown
      const customBackValidResponse = changedResponseType as customBackValidResponseType

      // テンプレートに配置済のバックバリデーションのキーをループ
      Object.keys(initializedBackValid).forEach((fixedKey) => {
        // カスタムバリデーションを取得
        if (fixedKey in customBackValidResponse) {
          // エラーレスポンス中にキーが存在する場合
          validationError.value[fixedKey] = customBackValidResponse[fixedKey][0]
        }
      })
    }

    return {
      isSave,
      isValid,
      validate,
      isShowDialog,
      isAfterToday,
      proximityId,
      availableLabels,
      constructionTypeOther: ConstructionTypes.OTHER,
      FileTypes,
      formRef,
      form,
      mapLoad,
      rules: proximityEditRule,
      mapCollapseChange: () => {
        // MapのCollapseが変化するとmap読み込みを有効化する
        mapLoad.value = true
      },
      returnTo,
      returnRoute,
      MessageTypes,
      targetMessageTypes,
      location_map_file_ref,
      ground_plan_file_ref,
      cross_section_file_ref,
      actual_place_photo_file_ref,
      foundation_drawing_file_ref,
      plan_temporary_work_file_ref,
      working_range_file_ref,
      cadastral_map_file_ref,
      survey_drawing_of_acreage_file_ref,
      fileRefs,
      errorFoundationDrawingFile,
      errorWorkingRangeFile,
      mapCenterLat,
      mapCenterLng,
      mapZoom,
      changeMapCenter,
      sumpleSubmissionsUrl: process.env.VUE_APP_PLOXIMITY_SUMPLE_SUBMISSIONS_URL,
      allowExts: APPLICANT_UPLOAD_FILE_EXTS,
      notSaved,
      validationError,
    }
  },
})
</script>

<style lang="scss" scoped>
.collapse-group,
.input-group {
  margin-top: 8px;
  margin-bottom: 8px;
}
.el-form {
  margin-top: -8px;
  margin-bottom: -8px;
  padding-bottom: 50px;
  width: calc(100% - 16px);
}

.el-form-item {
  ::v-deep(.end_plan_date_error) {
    margin-bottom: 0px;
  }
  ::v-deep(.end_plan_date_error .el-form-item__error) {
    left: 50%;
  }
}
.end_plan_date,
.start_plan_date,
.degree {
  margin-bottom: 1px;
}

.file-area {
  ::v-deep(label) {
    max-width: 130px;
    min-height: 40px;
    line-height: 40px;
  }
  ::v-deep(.el-button) {
    margin-right: 10px;
    margin-bottom: 5px;
  }
  ::v-deep(.el-button + .el-button) {
    margin-left: 0;
  }
}

span {
  display: inline-block;
}

.plan_date-label {
  margin-top: 10px;
}

.sumple-submissions {
  min-height: 40px;
  line-height: 40px;
}

.degree.is-error {
  margin-bottom: 15px;
}

.end_plan_date .is-error {
  margin-bottom: 20px;
}

.file-area ::v-deep(.el-button) {
  max-width: 700px;
}
</style>
